import React from 'react'

import {Slider} from '../UI/forms/index.js'
import {searchBar} from './styles.js'
import {sliderValueToTime, timeSlider, timeToSliderValue} from './time.js'

export interface TimeSliderProps {
    /** 'HH:mm', '00:00' to '24:00' */
    startTime: string
    endTime: string
    /** Also include what started before startTime / ends after endTime (the handle icons show it) */
    startInclude?: boolean
    endInclude?: boolean
    onTimeChange?: (startTime: string, endTime: string, startInclude: boolean, endInclude: boolean) => void
}

const valuesToLabel = (value1: number, value2: number) => ({label1: sliderValueToTime(value1), label2: sliderValueToTime(value2)})

/** The 00:00-24:00 range slider in quarters. Dragging a handle changes the times, clicking one toggles its include. */
export default function TimeSlider({startTime, endTime, startInclude, endInclude, onTimeChange}: TimeSliderProps) {
    return (
        <div style={{marginTop: searchBar.timeSliderMarginTop}}>
            <Slider
                min={timeSlider.min}
                max={timeSlider.max}
                step={timeSlider.step}
                diff={timeSlider.diff}
                value1={timeToSliderValue(startTime)}
                value2={timeToSliderValue(endTime)}
                value1Icon={startInclude ? 'mdi-arrow-expand-left' : 'mdi-arrow-collapse-left'}
                value2Icon={endInclude ? 'mdi-arrow-expand-right' : 'mdi-arrow-collapse-right'}
                startInclude={startInclude}
                endInclude={endInclude}
                handleLabels={['Begintijd', 'Eindtijd']}
                onClickValue1={() => onTimeChange?.(startTime, endTime, !startInclude, endInclude)}
                onClickValue2={() => onTimeChange?.(startTime, endTime, startInclude, !endInclude)}
                valuesToLabel={valuesToLabel}
                onChange={(value1, value2) => onTimeChange?.(sliderValueToTime(value1), sliderValueToTime(value2), startInclude, endInclude)}
            />
        </div>
    )
}
